<template>
  <div>
    <navbar ref="navbar" :automobileNumber="automobileNumber" />
    <div class="absolute-center" v-if="savingProcess">
      <spinner></spinner>
    </div>
    <v-content v-if="!savingProcess">
      <v-container>
        <v-flex class="p-2">
          <h3>
            {{ $t('docZN.ZN') }} №{{ doc.docNum }} {{ $t('docZN.dated') }}
            {{ doc.docDate }}
          </h3>
          <div class="d-flex align-items-center">
            <h5>{{ doc.clientName }}, {{ doc.automobileName }}</h5>
            <div class="d-flex flex-grow-0" v-if="doc.isPosted == 0">
              <v-btn
                icon
                small
                @click="startWorks(doc.id)"
                v-if="!documentIsStarted"
                class="tiny-button"
              >
                <i class="v-icon material-icons">play_circle_outline</i>
              </v-btn>
              <h6 class="duration-text" v-if="documentIsStarted">
                {{
                  $t('docZN.atWork') +
                  ' ' +
                  doc.durationOfWorks +
                  ' ' +
                  $t('docZN.min') +
                  '.'
                }}
              </h6>
              <v-btn
                icon
                small
                @click="stopWorks(0, doc.id)"
                v-if="documentIsStarted"
                class="tiny-button"
              >
                <i class="v-icon material-icons">pause_circle_outline</i>
              </v-btn>
              <v-btn
                icon
                small
                @click="stopWorks(1, doc.id)"
                v-if="documentIsStarted"
                class="tiny-button"
              >
                <i class="v-icon material-icons">stop</i>
              </v-btn>
            </div>
          </div>
        </v-flex>
      </v-container>

      <v-container>
        <div>
          <v-tabs v-model="currentTab" dark slider-color="yellow">
            <div class="action-panel d-flex q-buttons">
              <v-btn icon middle @click="showQuestionnaireForm">
                <i class="v-icon material-icons">playlist_add_check</i>
              </v-btn>
            </div>
            <v-tab :key="0" ripple>
              <div class="tab-bookmark d-flex align-items-center">
                <i class="v-icon material-icons">build</i>
                <h6 class="tab-name-holder d-none d-md-block">
                  {{ $t('docZN.works') }}
                </h6>
              </div>
            </v-tab>
            <v-tab :key="1" ripple>
              <div class="tab-bookmark d-flex align-items-center">
                <i class="v-icon material-icons">settings_applications</i>
                <h6 class="tab-name-holder d-none d-md-block">
                  {{ $t('docZN.items') }}
                </h6>
              </div>
            </v-tab>
            <v-tab :key="2" ripple>
              <div class="tab-bookmark d-flex align-items-center">
                <i class="v-icon material-icons">add_comment</i>
                <h6 class="tab-name-holder d-none d-md-block">
                  {{ $t('docZN.recommendations') }}
                </h6>
              </div>
            </v-tab>
            <div
              class="action-panel d-flex works-buttons"
              v-if="
                (documentcurrentTab == 0 || documentcurrentTab == 2) &&
                doc.isPosted == 0
              "
            >
              <v-btn
                icon
                middle
                @click="showAddTextDialog"
                v-if="documentcurrentTab == 2"
              >
                <i class="v-icon material-icons">add</i>
              </v-btn>
              <v-btn
                icon
                middle
                @click="selectProduct"
                v-if="
                  (documentcurrentTab == 0 && doc.available) ||
                  documentcurrentTab == 2
                "
              >
                <i class="v-icon material-icons">playlist_add</i>
              </v-btn>
              <v-btn icon middle @click="showCamera">
                <i class="v-icon material-icons">photo_camera</i>
              </v-btn>

              <v-btn icon middle @click="saveDoc" v-if="doc.isPosted == 0">
                <i
                  class="v-icon material-icons"
                  :class="{ blink: unsavedImagesCounter > 0 }"
                  >save</i
                >
              </v-btn>
            </div>

            <v-tabs-items touchless>
              <v-tab-item :key="0">
                <v-data-table
                  :headers="worksHeaders"
                  :items="doc.works"
                  hide-actions
                  class="elevation-1"
                  ref="dataTable"
                >
                  <template slot="items" slot-scope="props">
                    <tr
                      class="tab-row tr-"
                      :class="{
                        'tr-deleted': props.item.status === 1,
                        'active-row': props.item.isActive === 1,
                      }"
                      :key="props.item.id"
                      @dblclick="activateRow(props)"
                      @mouseover="setCurrentRow(props.index)"
                    >
                      <td class="table-col-tiny text-xs-left">
                        {{ props.index + 1 }}
                      </td>
                      <td width="99%" class="text-xs-left pos-rel">
                        {{ props.item.workName }}
                        <a
                          @click="markItem(props)"
                          v-if="doc.available"
                          class="ah-action"
                        >
                          <i class="material-icons">delete_outline</i>
                        </a>
                      </td>
                      <td class="text-xs-left">
                        <v-edit-dialog
                          :return-value.sync="props.item.count"
                          large
                          lazy
                          persistent
                          @save="saveQuantity(props)"
                          class="theme--dark"
                          ref="editDialog"
                          v-if="doc.available"
                        >
                          <div>{{ props.item.count }}</div>
                          <div slot="input" class="mt-3 title">К-во</div>
                          <v-text-field
                            slot="input"
                            v-model="props.item.count"
                            label="К-во"
                            single-line
                            autofocus
                            @focus="selectInputText"
                          ></v-text-field>
                        </v-edit-dialog>
                        <div v-if="!doc.available">{{ props.item.count }}</div>
                      </td>
                      <td class="text-xs-left">{{ props.item.price }}</td>
                      <td class="text-xs-left">
                        <div class="worker-text">
                          {{ props.item.workerName }}
                        </div>
                      </td>
                      <td class="action-holder ah-">
                        <a
                          @click="showAddCommentDialog(props)"
                          class="ah-action-a"
                          v-if="!props.item.comment"
                        >
                          <i class="material-icons">chat_bubble_outline</i>
                        </a>
                        <a
                          @click="showAddCommentDialog(props)"
                          class="ah-action-a"
                          v-if="props.item.comment"
                        >
                          <i class="material-icons">chat</i>
                        </a>
                      </td>
                    </tr>
                  </template>
                  <template slot="no-data">
                    <div v-if="noItemsWorks">
                      <h3 class="text-center">{{ $t('docZN.noRows') }}</h3>
                    </div>
                    <div v-else>
                      <spinner></spinner>
                    </div>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item :key="1">
                <v-data-table
                  :headers="goodsHeaders"
                  :items="doc.goods"
                  hide-actions
                  class="elevation-1"
                  ref="dataTable"
                >
                  <template slot="items" slot-scope="props">
                    <tr class="tab-row tr-" :key="props.item.id">
                      <td class="table-col-tiny text-xs-left">
                        {{ props.index + 1 }}
                      </td>
                      <td class="text-xs-left table-col-medium" width="99%">
                        {{ props.item.productName }}
                      </td>
                      <td class="text-xs-left">{{ props.item.count }}</td>
                      <td class="text-xs-left">{{ props.item.measureName }}</td>
                      <td class="text-xs-left table-col-small">
                        {{ props.item.storageName }}
                      </td>
                      <td class="action-holder">
                        <i class="material-icons" v-if="props.item.onHand == 1"
                          >local_grocery_store</i
                        >
                      </td>
                    </tr>
                  </template>
                  <template slot="no-data">
                    <div v-if="noItemsGoods">
                      <h3 class="text-center">{{ $t('docZN.noRows') }}</h3>
                    </div>
                    <div v-else>
                      <spinner></spinner>
                    </div>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item :key="2">
                <v-data-table
                  :headers="recommendationHeaders"
                  :items="doc.recommendations"
                  hide-actions
                  class="elevation-1"
                  ref="dataTable"
                >
                  <template slot="items" slot-scope="props">
                    <tr class="tab-row tr-" :key="props.item.id">
                      <td class="table-col-tiny text-xs-left">
                        {{ props.index + 1 }}
                      </td>
                      <td class="text-xs-left">{{ props.item.workName }}</td>
                      <td class="text-xs-left">{{ props.item.workerName }}</td>
                      <td class="action-holder">
                        <i class="material-icons" v-if="props.item.status == 1"
                          >check_circle_outline</i
                        >
                        <i class="material-icons" v-if="props.item.status == 2"
                          >highlight_off</i
                        >
                      </td>
                      <td class="action-holder ah-">
                        <a
                          @click="deleteRecommendation(props)"
                          class="ah-action"
                          v-if="props.item.newRecommendation"
                        >
                          <i class="material-icons">delete_outline</i>
                        </a>
                      </td>
                    </tr>
                  </template>
                  <template slot="no-data">
                    <div v-if="noItemsRecommendation">
                      <h3 class="text-center">{{ $t('docZN.noRows') }}</h3>
                    </div>
                    <div v-else>
                      <spinner></spinner>
                    </div>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
          <div class="d-flex">
            <h6 class="mt-2">{{ $t('docZN.reason') }}: {{ doc.reason }}</h6>
          </div>

          <v-spacer></v-spacer>
        </div>
      </v-container>
    </v-content>
    <camera ref="camera" :docImages="docImages" @updateImages="updateImages" />
    <product-select ref="selectProductModal" @prodItemSelected="addNewItem" />
    <add-text-dialog
      ref="addTextDialogModal"
      @addTextItem="addTextRecommendations"
    />
    <add-text-dialog ref="addComment" @addTextItem="addRowComment" />
    <questionnaire-form ref="questionnaireFormModal" />
    <confirm-dialog
      ref="confirmDialogModal"
      @actionСonfirmed="confirmDialogOK"
    />
  </div>
</template>

<script>
import axios from '@/services/axios'
import store from '@/services/store'
import Vue from 'vue'
import { WorkPlanFunctionsMixin } from '../components/WorkPlanFunctionsMixin.js'
import i18n from '@/plugins/i18n'

const getRowIndex = (i, id) => `${i}-${id}`

export default {
  name: 'DocZN',
  mixins: [WorkPlanFunctionsMixin],
  components: {
    navbar: () => import('../components/Navbar.vue'),
    spinner: () => import('../components/Spinner.vue'),
    'product-select': () => import('../components/ProductSelect.vue'),
    'add-text-dialog': () => import('../components/AddTextDialog.vue'),
    'questionnaire-form': () => import('../components/QuestionnaireForm.vue'),
    'confirm-dialog': () => import('../components/ConfirmDialog.vue'),
    camera: () => import('../components/Camera.vue'),
  },
  data: () => ({
    doc: { works: [] },
    docImages: [],
    //0: works 1: goods 2: recommendations
    currentTab: 0,
    worksHeaders: [
      {
        colId: 'worksColumnIndex',
        text: '№',
        value: 'index',
        align: 'center',
        class: 'table-col-tiny',
      },
      {
        colId: 'worksColumnWorkName',
        text: 'Наименование',
        value: 'workName',
        align: 'left',
        width: '99%',
      },
      {
        colId: 'worksColumnCount',
        text: 'н/ч',
        value: 'count',
        align: 'center',
        class: 'table-col-small',
      },
      {
        colId: 'worksColumnPrice',
        text: 'грн/ч',
        value: 'price',
        align: 'center',
        class: 'table-col-small',
      },
      {
        colId: 'worksColumnWorkerName',
        text: 'Исполнитель',
        value: 'workerName',
        align: 'left',
      },
      {
        colId: 'worksColumnOnHand',
        text: '',
        value: 'onHand',
        align: 'center',
      },
    ],
    goodsHeaders: [
      {
        colId: 'goodsColumnIndex',
        text: '№',
        value: 'index',
        align: 'center',
        class: 'table-col-tiny',
      },
      {
        colId: 'goodsColumnProductName',
        text: 'Наименование детали',
        value: 'productName',
        align: 'left',
      },
      {
        colId: 'goodsColumnCount',
        text: 'К-во',
        value: 'count',
        align: 'left',
        class: 'table-col-small',
      },
      {
        colId: 'goodsColumnMeasureName',
        text: 'Ед.',
        value: 'measureName',
        align: 'center',
        class: 'table-col-tiny',
      },
      {
        colId: 'goodsColumnStorageName',
        text: 'Склад',
        value: 'storageName',
        align: 'left',
      },
      {
        colId: 'goodsColumnOnHand',
        text: '',
        value: 'onHand',
        align: 'center',
      },
    ],
    recommendationHeaders: [
      {
        colId: 'recommendationColumnIndex',
        text: '№',
        value: 'index',
        align: 'center',
        class: 'table-col-tiny',
      },
      {
        colId: 'recommendationColumnWorkName',
        text: 'Наименование работы',
        value: 'workName',
        align: 'left',
      },
      {
        colId: 'recommendationColumnWorkerName',
        text: 'Исполнитель',
        value: 'workerName',
        align: 'left',
      },
      {
        colId: 'recommendationColumnStatus',
        text: '',
        value: 'status',
        align: 'center',
      },
    ],
    noItemsWorks: false,
    noItemsGoods: false,
    noItemsRecommendation: false,
    currentRow: undefined,
    currentRowIndex: undefined,
    savingProcess: false,
  }),
  created() {
    this.$nextTick(() => {
      this.fetchData()
      this.refreshListOptions()
    })
  },

  watch: {
    $route: 'fetchData',
  },
  getters: {},
  methods: {
    //'setRowStatus', 'startWorks', 'stopWorks', func in WorkPlanFunctionsMixin.js
    refreshListOptions() {
      this.worksHeaders.forEach((element) => {
        element.text = this.docZNTexts[element.colId]
      })
      this.goodsHeaders.forEach((element) => {
        element.text = this.docZNTexts[element.colId]
      })
      this.recommendationHeaders.forEach((element) => {
        element.text = this.docZNTexts[element.colId]
      })
    },
    async setRowStatus_(props, status) {
      this.setRowStatus(this.doc.id, props.item.workID, status).then((resp) => {
        if (resp !== false) {
          props.item.isActive = status
          Vue.set(this.doc.works, props.item.rowIndex, props.item)
        }
      })
    },
    changeRowStatus(props) {
      let isActive = props.item.isActive === 1 ? 0 : 1
      if (this.doc.documentIsStarted) {
        this.setRowStatus_(props, isActive)
      }
    },
    activateRow(props) {
      if (!this.doc.documentIsStarted) {
        this.startWorks(this.doc.id, props.item.workID).then((res) => {
          if (res) {
            this.changeRowStatus(props)
          }
        })
      } else {
        this.changeRowStatus(props)
      }
    },
    setIndication(id, documentIsStarted, durationOfWorks) {
      if (id && this.doc.id != id) return false
      if (documentIsStarted) {
        this.doc.documentIsStarted = documentIsStarted
      }
      if (durationOfWorks) {
        this.doc.durationOfWorks = durationOfWorks
      }
      setInterval(() => {
        if (this.doc.documentIsStarted == 1) {
          this.doc.durationOfWorks++
        } else {
          clearInterval()
        }
      }, 60000)
    },
    stopIndication(id) {
      if (id && this.doc.id != id) return false
      this.doc.documentIsStarted = 0
      this.doc.works.forEach((el) => {
        el.isActive = 0
      })
    },
    fetchData() {
      this.noItemsWorks = false
      this.noItemsGoods = false
      this.noItemsRecommendation = false
      axios
        .request({
          url: '/OrdersDetails',
          params: {
            requestType: 1,
            id: this.$route.params.id,
          },
        })
        .then((resp) => {
          this.doc = resp.data.documents[0]
          if (!this.doc.works) this.doc.works = []
          if (this.doc.works.length) {
            this.doc.works.forEach((el, i) => {
              el.id = getRowIndex(i, el.workID)
              el.rowIndex = i
              el.status = 0
            })
          } else {
            this.noItemsWorks = true
          }
          if (this.doc.goods.length) {
            this.doc.goods.forEach((el, i) => {
              el.id = getRowIndex(i, el.productID)
            })
          } else {
            this.noItemsGoods = true
          }
          if (this.doc.recommendations.length) {
            this.doc.recommendations.forEach((el, i) => {
              el.id = getRowIndex(i, el.workID)
            })
          } else {
            this.noItemsRecommendation = true
          }

          if (this.$refs.navbar && this.$refs.navbar.setCarSearchValue) {
            this.$refs.navbar.setCarSearchValue(
              resp.data.documents[0].automobileNumber
            )
          }

          if (resp.data.documents[0].images) {
            this.docImages = resp.data.documents[0].images
          } else {
            this.docImages = []
          }

          this.setIndication()
          this.checkWriteAvailability()
        })
        .catch((error) => {
          console.error('axios/request/OrdersDetails', error)
        })
    },
    async saveDoc() {
      this.savingProcess = true
      const getPng = function (imgElement) {
        let imgPromise = new Promise((resolve, reject) => {
          let canvas = document.createElement('canvas')
          let context = canvas.getContext('2d')
          let img = document.createElement('img')
          img.onload = () => {
            canvas.width = img.width
            canvas.height = img.height
            context.drawImage(img, 0, 0)
            let imgData = canvas.toDataURL('image/jpeg', 0.5)
            resolve({preId:imgElement.preId, data:imgData})
          }
          img.src = imgElement.data
        })
        return imgPromise
      }
      let onlyRecommendations = 0
      let onlyRowComments = 0
      if (this.currentTab === 2) {
        onlyRecommendations = 1
      } else {
        if (!this.checkWriteAvailability()) return
      }
      if (!this.doc.available) {
        onlyRowComments = 1
      }
      let tmpArray = this.docImages.filter((el) => {
        return el.id || el.data.indexOf('data:video') != -1 ? false : true
      })
      
      let tmpVideoArray = this.docImages.filter((el) => {
        return el.data.indexOf('data:video') == -1 ? false : true
      })
      let imgPromices = []
      tmpArray.forEach((el,i) => {
        imgPromices.push(getPng({...el}))
      })
      let jpgImages = await Promise.all(imgPromices)
      let sendVideo = async (videoObj) => {
        await axios.request({
          url: 'prepareLongRequest',
          method: 'post',
        })
        const form = new FormData()
        form.append('docId', this.doc.id)
        form.append('preId', videoObj.preId)
        form.append('video', videoObj.data)
        let sendVideoResp = axios.request({
          url: 'SendVideo',
          method: 'post',
          data: form,
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        return sendVideoResp
      }
      let videoProcessors = []

      let videoSendingRsult = true
      for (let i = 0; i < tmpVideoArray.length; i++) {
        videoProcessors.push(sendVideo(tmpVideoArray[i]))
      }

      let videoInfo = await Promise.all(videoProcessors)
      videoInfo.forEach((el, i) => {
        if (el.status != 200) {
          videoSendingRsult = false
        } else {
          let videoId = el.data.id
          let videoPreId = el.data.preId
          this.docImages.forEach((imgEl, i) => {
            if (imgEl.preId == videoPreId) {
              imgEl.id = videoId
              Vue.set(this.docImages, i, imgEl)
            }
          })
        }
      })
      await axios
        .request({
          url: 'SetOrderData',
          method: 'post',
          data: {
            doc: this.doc,
            onlyRecommendations: onlyRecommendations,
            onlyRowComments: onlyRowComments,
            images: jpgImages,
          },
        })
        .then((resp) => {
          if (onlyRecommendations == 1) {
            this.$emit('showSnack', {
              color: 'success',
              text: this.docZNTexts.recommendationsSaved,
            })
          } else {
            this.$emit('showSnack', {
              color: 'success',
              text: this.docZNTexts.recommendationsSaved,
            })
          }
          if(resp.data.imagesId) {
            resp.data.imagesId.forEach((el,i) => {
              let imageId = el.id
              let imagePreId = el.preId
              this.docImages.forEach((el, i) => {
                if (el.preId == imagePreId) {
                  el.id = imageId
                  Vue.set(this.docImages, i, el)
                }
              })
            })
          } 
        })
      this.savingProcess = false
    },
    selectProduct() {
      if (this.currentTab === 2) {
        store.commit('changeStatusShowRecommendationsList', true)
      } else {
        store.commit('changeStatusShowRecommendationsList', false)
      }
      this.$refs.selectProductModal.show()
    },
    showAddTextDialog() {
      this.$refs.addTextDialogModal.show()
    },
    showAddCommentDialog(props) {
      this.currentRow = props
      let strComment = this.currentRow.item.comment
      this.$refs.addComment.show(
        strComment,
        this.docZNTexts.commentTo + ' ' + this.currentRow.item.workName
      )
    },
    showConfirmDialog(dialogData) {
      this.$refs.confirmDialogModal.show(dialogData)
    },
    showQuestionnaireForm() {
      if (this.doc.questionnaireForms.length === 1) {
        this.$refs.questionnaireFormModal.show(
          this.doc,
          this.doc.questionnaireForms[0].qFormID
        )
      } else {
        this.$store.dispatch('showSnackMessage', {
          color: 'error',
          text: this.docZNTexts.questionnaireAbsent,
        })
        //this.$refs.questionnaireFormModal.show(this.doc,this.doc.questionnaireForms[0].qFormID)
      }
    },
    deleteRecommendation(item) {
      this.doc.recommendations.splice(item.index, 1)
    },
    addRowComment(strRecommendation) {
      if (this.currentRow) {
        this.currentRow.item.comment = strRecommendation
        Vue.set(
          this.doc.works,
          this.currentRow.item.rowIndex,
          this.currentRow.item
        )
      }
    },
    setCurrentRow(index) {
      this.$nextTick(() => (this.currentRowIndex = index))
    },
    addTextRecommendations(strRecommendation) {
      const newItem = Object.assign(
        {},
        {
          id: getRowIndex(this.doc.recommendations.length, 'strRecommendation'),
          workID: 'strRecommendation',
          workName: strRecommendation,
          newRecommendation: true,
        }
      )
      this.doc.recommendations.push(newItem)
      if (this.noItemsRecommendation) {
        this.noItemsRecommendation = false
        this.$refs.dataTable.updatePagination()
      }
    },
    addNewItem(item) {
      if (this.currentTab === 2) {
        this.addNewRecommendation(item)
      } else {
        this.addNewWorkItem(item)
      }
    },
    addNewWorkItem(item) {
      const newItem = Object.assign(
        {},
        {
          id: getRowIndex(this.doc.works.length, item.id),
          workID: item.id,
          workName: item.name,
          measureName: item.unit,
          count: 1,
          workerID: store.state.userData.userId,
          workerName: store.state.userData.userName,
          status: 2,
        }
      )
      this.doc.works.push(newItem)
      if (this.noItemsWorks) {
        this.noItemsWorks = false
        this.$refs.dataTable.updatePagination()
      }
    },
    addNewRecommendation(item) {
      const newItem = Object.assign(
        {},
        {
          id: getRowIndex(this.doc.recommendations.length, item.id),
          workID: item.id,
          workName: item.name,
          newRecommendation: true,
        }
      )
      this.doc.recommendations.push(newItem)
      if (this.noItemsRecommendation) {
        this.noItemsRecommendation = false
        this.$refs.dataTable.updatePagination()
      }
    },
    confirmDialogOK(dialogData) {
      if (dialogData.dialogID === 'closePreviousDocument') {
        if (dialogData.action === 2) {
          this.stopWorks(1, dialogData.previousDocument).then(() => {
            this.startWorks(this.doc.id).then((res) => {
              if (res && dialogData.rowData) {
                this.changeRowStatus(dialogData.rowData)
              }
            })
          })
        } else {
          this.stopWorks(0, dialogData.previousDocument).then(() => {
            this.startWorks(this.doc.id).then((res) => {
              if (res && dialogData.rowData) {
                this.changeRowStatus(dialogData.rowData)
              }
            })
          })
        }
      }
    },
    markItem(props) {
      if (this.currentRowIndex == props.index) {
        props.item.status = props.item.status !== 1 ? 1 : 0
        Vue.set(this.doc.works, props.item.rowIndex, props.item)
      }
    },
    saveQuantity(props) {
      props.item.status = props.item.status ? props.item.status : 3
      Vue.set(this.doc.works, props.item.rowIndex, props.item)
      this.$emit('showSnack', {
        color: 'success',
        text: this.docZNTexts.countChanged,
      })
    },
    selectInputText(ev) {
      ev.target.setSelectionRange(0, ev.target.value.length)
    },
    checkWriteAvailability() {
      if (this.doc.isPosted) {
        this.$emit('showSnack', {
          color: 'info',
          text: this.docZNTexts.documentIsPostedError,
        })
        return false
      }
      return true
    },
    showCamera() {
      this.$refs.camera.show()
    },
    updateImages(images) {
      this.docImages = images
    },
  },
  computed: {
    automobileNumber() {
      if (this.doc) {
        return this.doc.automobileNumber
      } else {
        return ''
      }
    },
    documentcurrentTab: function () {
      return this.currentTab
    },
    documentIsStarted: function () {
      return this.doc.documentIsStarted === 1
    },
    docZNTexts: function () {
      return i18n.messages[i18n.locale].docZN
    },
    globalTexts: function () {
      return i18n.messages[i18n.locale].global
    },
    unsavedImagesCounter: function () {
      let tmpArray = this.docImages.filter((el) => {
        return el.id ? false : true
      })
      return tmpArray.length
    },
  },
}
</script>

<style scoped lang="scss">
@import '../_scss/breakpoints';

.works-buttons {
  order: 2;
  margin-left: auto;
}

.q-buttons {
  order: -1;
  margin-left: 0;
}

.tiny-button {
  margin: 2px 6px;
  @include xs {
    margin: 0;
  }
}

h3 {
  @include sm {
    font-size: 18px;
  }
  @include xs {
    font-size: 14px;
    margin-bottom: 0px;
  }
}

h5 {
  @include xs {
    font-size: 12px;
    margin-bottom: 0;
    line-height: 1;
  }
}

.duration-text {
  margin: 7px 0px 7px 0px;
}

.cutter {
  height: 20px;
}

/deep/ .action-panel {
  .v-btn--icon {
    @include xs {
      width: 30px;
    }
  }
}

.ah-action-a {
  height: 100%;
  align-items: center;
  display: flex;
  margin-right: 15px;
}

.tab-row {
  @include xxs {
    height: 30px;
  }
  &:hover {
    /deep/ .ah-action {
      display: inline-flex;
      padding-right: 10px;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0 auto 15px;
      @include xs {
        padding-right: 3px;
      }
    }
  }
  &.tr-deleted {
    text-decoration: line-through;
    color: #929292;
  }

  /deep/ .action-holder {
    position: relative;
    min-width: 50px;
    display: flex;
    padding: 0;
  }
  /deep/ .ah-action {
    display: none;
    height: 100%;
    align-items: center;
  }
}

/deep/ .v-tabs__item {
  margin: 6px 0px;
  padding: 0px 4px;
  @include xs {
    padding: 0px 1px;
  }
}

/deep/ .v-tabs__container {
  max-width: 100% !important;
  @include xs {
    height: 40px;
  }
  .v-icon {
    @include xs {
      font-size: 20px;
    }
  }
}

.tab-name-holder {
  margin-bottom: 0;
  margin-left: 4px;
  font-size: 14px;
}

.tab-bookmark {
  border-width: 1px;
  border-color: white;
  border-style: dashed;
  padding: 5px;
  text-align: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  align-items: center;
  @include md {
    padding: 5px 10px;
  }
}

.active-row {
  background: rgb(91, 163, 82) !important;
}

.absolute-center {
  margin: auto;
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.blink {
  animation-name: blinker;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(1, 2, 0, 1);
  animation-duration: 1s;
  -webkit-animation-name: blinker;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: cubic-bezier(1, 2, 0, 1);
  -webkit-animation-duration: 1s;
}

@keyframes blinker {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@-webkit-keyframes blinker {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
